import {apolloClient} from 'shared/apollo'
import updateSessionsCollectionMutation from 'shared/graphql/updateSessionsCollection.gql'
import queryUserSessions from 'shared/graphql/queryUserSessions.gql'
import querySession from 'shared/graphql/querySession.gql'

export default function updateSessionsCollection({sessionIds, oldCollectionId, newCollectionId}) {
	return apolloClient.mutate({
		mutation: updateSessionsCollectionMutation,

		variables: {
			sessionIds,
			collectionId: newCollectionId,
		},

		update: (cache, result) => {
			if (!result?.data?.update_sessions?.affected_rows) {
				throw new Error(`Session(s) ${sessionIds} could not be moved.`)
			}

			const sessionIdSet = new Set(sessionIds)
			sessionIdSet.forEach(sessionId => {
				let data = cache.readQuery({
					query: querySession,
					variables: {id: sessionId},
				})
				if (!data?.session) return

				data = JSON.parse(JSON.stringify(data))
				data.session.collectionId = newCollectionId

				cache.writeQuery({
					query: querySession,
					variables: {id: sessionId},
					data,
				})
			})

			let data = cache.readQuery({
				query: queryUserSessions,
				variables: {collectionId: oldCollectionId},
			})
			if (!data) return

			data = JSON.parse(JSON.stringify(data))
			data.userSessionsList = data.userSessionsList.filter(session => !sessionIdSet.has(session.id))

			cache.writeQuery({
				query: queryUserSessions,
				variables: {collectionId: oldCollectionId},
				data,
			})
		},

		optimisticResponse: {
			update_sessions: {
				affected_rows: sessionIds.length,
				__typename: 'sessions_mutation_response',
			},
		},
	})
}
